import React, { useState } from "react";
import { Upload, message } from "antd";
import { InboxOutlined } from "@ant-design/icons";
import "./index.scss";

const DnD = ({ setFormDataState }) => {
  const [fileList, setFileList] = useState([]);

  const allowedExtensions = [".xls", ".xlsx", ".txt", ".csv"];

  const beforeUpload = (file) => {
    const fileName = file.name.toLowerCase();
    const isAllowed = allowedExtensions.some(ext => fileName.endsWith(ext));

    if (!isAllowed) {
      message.error(`${file.name} is not allowed. Only .xls, .xlsx, .csv, and .txt files are accepted.`);
      return Upload.LIST_IGNORE;
    }

    const isSizeValid = file.size / 1024 / 1024 < 100;
    if (!isSizeValid) {
      message.error(`${file.name} exceeds 100MB size limit.`);
      return Upload.LIST_IGNORE;
    }

    // ✅ Manually control file list & pass to parent
    const newFileList = [file];
    setFileList(newFileList);
    setFormDataState(file);
    return false;
  };

  const onRemove = () => {
    setFileList([]);
    setFormDataState(null);
  };

  return (
    <Upload.Dragger
      name="file"
      multiple={false}
      fileList={fileList}
      beforeUpload={beforeUpload}
      onRemove={onRemove}
      accept=".xls,.xlsx,.txt,.csv" // ✅ browser level restriction too
    >
      <p className="ant-upload-drag-icon">
        <InboxOutlined />
      </p>
      <p className="ant-upload-text">Click or drag a file to this area to upload</p>
      <p className="ant-upload-hint">
        Only Excel (.xls, .xlsx, .csv) and text (.txt) files are allowed. One file at a time.
      </p>
    </Upload.Dragger>
  );
};

export default DnD;